import { Resource } from "./Resource"

export const ResourceGroup = ({name, resources}) => {
  return (
    <div>
      <h2 className="mb-4 text-2xl font-bold">{name}</h2>
      <div className="mb-4 grid grid-cols-2 gap-4 md:grid-cols-2">
        {resources?.map((resource) => <Resource key={resource.id} {...resource} />)}
      </div>
    </div>
  )
}